












































import {Component, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import AuthRequest from '../../model/request/AuthRequest'
import * as Helpers from '@/helpers'

interface HCaptchaIframe extends HTMLIFrameElement {
  'data-hcaptcha-response': string
}

@Component
export default class SignInView extends Vue {
  @Action('auth/signIn') signIn!: Function
  @Action('refreshView') refreshView!: Function

  model = new AuthRequest()

    created() {
        if (Helpers.isLogged()) {
            if (Helpers.isSac()) {
                this.$router.replace('/reports/delivery/sac')
            } else {
                this.$router.replace('/cockpit')
            }
        }
    }

    async mounted() {
      await this.renderCaptcha()
    }

    get hCaptchaDataKey() {
      return process.env.VUE_APP_HCAPTCHA_DATA_SITE_KEY
    }

    async renderCaptcha() {
      // @ts-ignore
      const captcha = window.hcaptcha

      if (captcha) {
        captcha.render('h-captcha', {
          sitekey: this.hCaptchaDataKey,
        })
      }
    }

    populateCaptchaResponse() {
      if (!this.hCaptchaDataKey) {
        Helpers.abort('view.signIn.captchaError')
        return
      }

      const iframeDivContainer = document.querySelector(`div[data-sitekey="${this.hCaptchaDataKey}"]`)

      if (!iframeDivContainer) {
        Helpers.abort('view.signIn.captchaError')
        return
      }

      const iframe = iframeDivContainer.querySelector('iframe') as HCaptchaIframe
      const captchaCode = iframe ? iframe.getAttribute('data-hcaptcha-response') : null

      if (!captchaCode) {
        Helpers.abort('view.signIn.captchaError')
        return
      }

      this.model.captchaResultCode = captchaCode
    }

    async handleSubmit() {
      try {
        this.populateCaptchaResponse()
        await this.signIn(this.model)
      } catch {
        await this.$nextTick()
        await Helpers.sleep(500)
        await this.renderCaptcha()
      }
    }
}
